import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';
import { MarginValidationLog } from '../models/margin-validation-log.model';

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorLogService extends MarginCalculatorBaseService {
    constructor(private readonly _http: HttpClient) {
        super();
    }

    postMarginValidationLog(data: MarginValidationLog): Observable<void> {
        return this._http.post<void>(`${this.coreApiPath}/margin-calculator/margin-validation-log`, data);
    }
}
